import { React } from "react";

import "../../../assets/stlyes/Dashboard/PPRGraph.scss";

import graphSVG1 from "../../../assets/images/pprPieChart.svg";

const VennDiagramSmallComponent = (props) => {
  const { subjects } = props;
  return (
    <div className="ppr-graph_">
      <img src={graphSVG1} alt="" width={150} height={150} />
      <div className="reading-labels_">
        <span className="label-values reading-value">{`${subjects.reading.passPercent}`}</span>
      </div>
      {/* <div className="reading-writing-labels_">
        <span className="label-values reading-writing-value">{`${subjects.readingOrWriting.passPercent}`}</span>
      </div> */}
      <div className="writing-labels_">
        <span className="label-values writing-value">{`${subjects.writing.passPercent}`}</span>
      </div>
      {/* <div className="writing-maths-labels_">
        <span className="label-values writing-maths-value">{`${subjects.mathOrWritingCount.passPercent}`}</span>
      </div> */}
      <div className="maths-labels_">
        <span className="label-values maths-value">{`${subjects.maths.passPercent} `}</span>
      </div>
      {/* <div className="maths-reading-labels_">
        <span className="label-values maths-reading-value">{`${subjects.mathsOrReading.passPercent}`}</span>
      </div> */}
      <div className="allsubject-labels_">
        <span className="label-values allsubject-value">{`${subjects.mathOrWritingOrReading.passPercent}`}</span>
      </div>
    </div>
  )
}

export { VennDiagramSmallComponent }